module.exports = __webpack_public_path__ + "static/media/palmtree-big-1.4a46c31a.png";